var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFriendDeposit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.5,
    height: 11.5,
    viewBox: "0 0 11.5 11.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-wallet-3814518",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122257",
    "data-name": "Path 122257",
    d: "M5.155,1.546h7.424V.154A.155.155,0,0,0,12.4,0L5.129,1.239A.155.155,0,0,0,5,1.392v.183A.459.459,0,0,1,5.155,1.546Z",
    transform: "translate(-4.231 0)",
    fill: "#5142fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122258",
    "data-name": "Path 122258",
    d: "M12.722,13.937h2.39V12.194A.189.189,0,0,0,14.928,12H5.184A.189.189,0,0,0,5,12.194v5.192a2.471,2.471,0,0,1,2.586,0,2.753,2.753,0,0,1,1.29,2.362c0,.065,0,.129-.009.194h6.062a.189.189,0,0,0,.184-.194V17.812h-2.39a.567.567,0,0,1-.552-.581V14.518A.567.567,0,0,1,12.722,13.937Z",
    transform: "translate(-4.231 -10.144)",
    fill: "#5142fc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_276",
    "data-name": "Ellipse 276",
    cx: 0.257,
    rx: 0.257,
    transform: "translate(9.893 5.75)",
    fill: "#dcf8c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122259",
    "data-name": "Path 122259",
    d: "M48.629,24H46.155a.155.155,0,0,0-.155.155V26.32a.155.155,0,0,0,.155.155h2.475a.155.155,0,0,0,.155-.155V24.155A.155.155,0,0,0,48.629,24Zm-1.237,1.7a.464.464,0,1,1,.464-.464A.464.464,0,0,1,47.392,25.7Z",
    transform: "translate(-37.284 -19.487)",
    fill: "#dcf8c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122260",
    "data-name": "Path 122260",
    d: "M2.653,42.034H2.034v.619a.155.155,0,0,1-.309,0v-.619H1.106a.155.155,0,1,1,0-.309h.619v-.619a.155.155,0,0,1,.309,0v.619h.619a.155.155,0,1,1,0,.309Zm-.771-2.006a1.854,1.854,0,1,0,1.854,1.854A1.854,1.854,0,0,0,1.882,40.028Z",
    transform: "translate(-0.028 -32.236)",
    fill: "#dcf8c5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriendDeposit);
export default __webpack_public_path__ + "static/media/friend-deposit.44db2fda0a97f5f6e7673499731cdc5a.svg";
export { ForwardRef as ReactComponent };